<template>
  <div class="add-item-table-component">
    <slot></slot>

    <div class="d-flex justify-content-end my-1">
      <input
        type="button"
        :value="isEditingIndex === null ? 'Adicionar' : 'Modificar'"
        class="btn btn-add"
        @click="onAddItemClick"
      />
    </div>

    <table>
      <thead>
        <tr>
          <th v-for="(column, indexTh) of columns" :key="indexTh">{{ column.label }}</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, indexTr) of getItems" :key="indexTr">
          <td v-for="(column, indexTd) of columns" :key="indexTd">
            <template v-if="typeof(item[column.key]) === 'boolean'">
              <label class="switch">
                <input type="checkbox" v-model="item[column.key]" />
                <span class="slider"></span>
              </label>
            </template>
            <template v-else>
              <span>{{ (item[column.key] && String(item[column.key]).length) ? (item[column.key + 'SelectValue'] || item[column.key]) : '-' }}</span>
            </template>
          </td>
          <td>
            <div class="table-actions">
              <i
                class="fa fa-trash fa-2x"
                @click="onRemoveClick(item)"
                v-if="actions.includes('delete')"
              ></i>
              <!-- <i
                class="fa fa-edit fa-2x cursor-pointer"
                v-if="!item.editing && actions.includes('edit')"
                @click="onEditClick(item)"
              ></i> -->
            </div>
          </td>
        </tr>
        <tr v-if="getItems.length == 0">
          <td :colspan="columns.length + 1">
            <p class="text text-center">Nenhum ítem adicionado ainda</p>
          </td>
        </tr>
      </tbody>
    </table>

    <div :class="{'form-group': true, 'required': required }">
      <input
        type="hidden"
        class="form-control"
        :name="name"
        :value="(getItems.length > 0) ? JSON.stringify(items) : ''"
      />
      <label :for="columns.length && columns[0].key" class="error">{{ this.emptyErrorMessage }}</label>
    </div>
    <input type="hidden" :name="name + '_deleted'" :value="JSON.stringify(savedItemsDeleted)" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    value: {
      required: false,
      default: () => [],
    },
    idField: {
      required: true,
    },
    actions: {
      required: false,
      default: () => ["delete", "edit"],
    },
    dontDuplicate: {
      required: false,
      default: () => [],
    },
    emptyErrorMessage: {
      required: false,
      default: "Erro, informe pelo menos um item",
    },
    validation: {
      required: false,
      default: null,
    },
    required: {
      required: false,
      default: true,
    },
  },
  data: () => ({
    columns: [],
    items: [],
    savedItemsDeleted: [],
    isEditingIndex: null,
  }),
  computed: {
    getItems() {
      return this.items.filter((item) => !item.deleted);
    },
  },
  methods: {
    onAddItemClick() {
      const item = {
        _id: Math.random().toString(36).substr(2, 9), // used when not saved
        editing: false,
      };
      let hasError = false;

      this.$el.querySelectorAll(".form-fields .form-group").forEach((node) => {
        const formControl = node.querySelector(".form-control");
        const notRequired =
          formControl.getAttribute("data-not-required") &&
          formControl.getAttribute("data-not-required") == "true";

        if (
          formControl.getAttribute("disabled") === null &&
          formControl.getAttribute("type") !== "checkbox" &&
          !notRequired &&
          formControl.value === ""
        ) {
          node.classList.add("error");
          hasError = true;
          return;
        }
        node.classList.remove("error");
        item[formControl.getAttribute("name")] =
          formControl.getAttribute("type") === "checkbox"
            ? formControl.checked
            : formControl.value;

        if (
          formControl.tagName === "SELECT" &&
          formControl.selectedIndex >= 0
        ) {
          item[formControl.getAttribute("name") + "SelectValue"] =
            formControl.options[formControl.selectedIndex].text;
        }

        if (
          this.isEditingIndex === null &&
          this.dontDuplicate.includes(formControl.getAttribute("name")) &&
          this.items.find(
            (item) =>
              item[formControl.getAttribute("name")] == formControl.value
          )
        ) {
          hasError = true;
          const columnLabel = this.columns.find(
            (column) => column.key === formControl.getAttribute("name")
          ).label;
          this.$toast.error(`${columnLabel} já foi adicionado(a)`);
        }
      });

      // let _items = {...item};
      const isExist = this.items.some(element => {
        return element.num_unidade_producao == item.num_unidade_producao
      })
      if(isExist){
        this.$toast.error('Produto já foi adicionado');
        return;
      }
      if (!hasError && this.validation) {
        hasError = !this.validation(item, this.items);
      }

      if (!hasError) {
        if (this.isEditingIndex === null) {
          this.items.push(item);
        } else {
          item.editing = false;
          this.items[this.isEditingIndex] = {
            ...this.items[this.isEditingIndex],
            ...item,
          };
          this.items = JSON.parse(JSON.stringify(this.items));
          this.isEditingIndex = null;
        }

        this.$emit("change", JSON.parse(JSON.stringify(this.items)));

        this.$el
          .querySelectorAll(".form-fields .form-group .form-control")
          .forEach((formControl) => {
            if (
              formControl.getAttribute("data-not-apply") &&
              formControl.getAttribute("data-not-apply") == "true"
            ) {
              formControl.value = "";
              formControl.removeAttribute("readonly");

              const doesntApply = formControl.parentElement.querySelector(
                ".not-apply"
              );
              doesntApply.checked = false;
            } else if (formControl.getAttribute("readonly") === null) {
              formControl.value = "";
              formControl.removeAttribute("disabled");
            }
          });
      }
    },
    onEditClick(itemEl) {
      const index = this.items.findIndex((el) =>
        el._id
          ? el._id === itemEl._id
          : el[this.idField] === itemEl[this.idField]
      );
      const item = this.items[index];
      item.editing = true;
      this.isEditingIndex = index;
      const event = new Event("change");

      this.$el
        .querySelectorAll(".form-fields .form-group .form-control")
        .forEach((formControl, index) => {
          if (
            formControl.getAttribute("data-not-apply") &&
            formControl.getAttribute("data-not-apply") == "true"
          ) {
            formControl.value = item[formControl.getAttribute("name")];
            if (formControl.value === "NÃO SE APLICA") {
              formControl.setAttribute("readonly", true);

              const doesntApply = formControl.parentElement.querySelector(
                ".not-apply"
              );
              doesntApply.checked = true;
            }
          } else if (formControl.getAttribute("readonly") === null) {
            if (formControl.getAttribute("type") !== "file") {
              formControl.value = item[formControl.getAttribute("name")];
            }
            formControl.dispatchEvent(event);
            if (index === 0) {
              formControl.focus();
            }
          }
        });
    },
    onRemoveClick(itemEl) {
      const index = this.items.findIndex((el) =>
        el._id
          ? el._id === itemEl._id
          : el[this.idField] === itemEl[this.idField]
      );
      const item = this.items[index];
      item.deleted = true;
      if (item[this.idField]) {
        this.savedItemsDeleted.push(item[this.idField]);
      } else {
        this.items.splice(index, 1);
      }
      this.items = JSON.parse(JSON.stringify(this.items));
      this.$emit("change", JSON.parse(JSON.stringify(this.items)));
    },
    adjustItemsList() {
      if (Array.isArray(this.value) && this.value.length) {
        this.items = this.value.map((item) => {
          Object.keys(item).forEach((key) => {
            const formControl = this.$el.querySelector(
              `.form-fields .form-group .form-control[name="${key}"]`
            );
            if (formControl && formControl.tagName === "SELECT") {
              if (Array.from(formControl.options).length > 1) {
                const option = Array.from(formControl.options).find(
                  (opt) => opt.value == item[key]
                );
                item[key + "SelectValue"] = option ? option.text : "";
              }
            }
          });
          item.editing = false;
          !item.deleted && (item.deleted = false);
          return item;
        });
      }
    },
  },
  mounted() {
    this.$el.querySelectorAll(".form-fields .form-group").forEach((node) => {
      const label = node.querySelector("label");
      const formControl = node.querySelector(".form-control");
      const doesntApply = formControl.getAttribute("data-not-apply");
      this.columns.push({
        label: label.innerHTML,
        key: formControl.getAttribute("name"),
      });

      if (doesntApply && doesntApply == "true") {
        const doesntApplyLabel = document.createElement("label");
        doesntApplyLabel.innerHTML = "Não se aplica";
        const checkbox = document.createElement("input");
        checkbox.setAttribute("type", "checkbox");
        checkbox.classList.add("not-apply");
        doesntApplyLabel.prepend(checkbox);
        node.appendChild(doesntApplyLabel);

        checkbox.addEventListener("change", function (ev) {
          const val = ev.target.checked;
          if (val) {
            formControl.setAttribute("readonly", true);
            formControl.value = "NÃO SE APLICA";
          } else {
            formControl.removeAttribute("readonly");
            formControl.value = "";
          }
        });
      }
    });

    this.adjustItemsList();
  },
};
</script>
